import React, { useCallback, memo } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, MenuItem, FormControl, Select, Button, TextField, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const useStyles = makeStyles((theme)=>({
    checkBox: {
      borderRight: '1px solid #D3D3D3',
      width: '8%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
  
      [theme.breakpoints.down(1025)]: {
        
      } 
    },
    oneBox: {
      borderRight: '1px solid #D3D3D3',
      width: '10%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      wordBreak:'break-all',
  
      [theme.breakpoints.down(1025)]: {
        width: '46%',
      } 
    },
    twoBox: {
      borderRight: '1px solid #D3D3D3',
      display: 'flex',
      flexDirection: 'column',
      width: '10%',
      wordBreak:'break-all',
    },
    threeBox: {
      borderRight: '1px solid #D3D3D3',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '10%',
      wordBreak:'break-all',
    },
    inBox1: {
      borderBottom:'1px solid #D3D3D3',
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    inBox2: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
   
    itemBox: {
      borderBottom: '1px solid #D3D3D3',
      display: 'flex',
  
      [theme.breakpoints.down(1025)]: {
        display:'none'
      } 
    },
    mobileItemBox:{
      display:'none',
  
      [theme.breakpoints.down(1025)]: {
        display:'block',
        borderBottom: '1px solid #D3D3D3',
        display: 'flex',
      } 
    },
  
  }));
  

const MemberConfigList = ({
    checks, 
    setChecks, 
    data, 
    setData,
    picList
}) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    let navigate = useNavigate();
    

    
  return (
    <>
    {
        data.map((item, index) => 
                <div 
                  style={{
                    backgroundColor: index % 2 == 0 && '#F2F2F2'
                  }}
                  key={index}
                >
                  <MemItem 
                      checks={checks} 
                      setChecks={setChecks} 
                      data={data} 
                      setData={setData}
                      picList={picList}
                      mbNo={item['mb_no']} 
                      mbId={item['mb_id']} 
                      mbName={item['mb_name']}
                      mbNick={item['mb_nick']}
                      mbMailling={item['mb_mailling']} 
                      mbSms={item['mb_sms']} 
                      mbHp={item['mb_hp']} 
                      mbTel={item['mb_tel']} 
                      mbLevel={item['mb_level']} 
                      mbPoint={item['mb_point']} 
                      mbTodayLogin={item['mb_today_login']} 
                      mbDateTime={item['mb_datetime']} 
                      mbRegion={item['mb_region']} 
                      mbStorname={item['mb_storename']} 
                      picId={item['pic_id']}
                      classes={classes}
                      navigate={navigate}
                  />
                </div>
        )
      }
    </>
  )
}


const MemItem = memo(({
        checks, 
        setChecks, 
        data, 
        setData,
        picList,
        mbNo, 
        mbId, 
        mbName,
        mbNick,
        mbMailling, 
        mbSms, 
        mbHp, 
        mbTel, 
        mbLevel, 
        mbPoint, 
        mbTodayLogin, 
        mbDateTime, 
        mbRegion, 
        mbStorname, 
        picId,
        classes,
        navigate
    }) => {

    const idx = data.findIndex((item) => item['mb_no'] === mbNo)

    return(
        <div className={classes.box2} key={mbNo}>
          <div className={classes.itemBox} >
              <CeckCompo 
                classes={classes}
                checks={checks}
                setChecks={setChecks}
                mbNo={mbNo}
              />
        
              <div className={classes.oneBox}>
                {mbId}
              </div>
        
              <div className={classes.twoBox}>
                <div className={classes.inBox1}>
                  {mbName}
                </div>
                <div className={classes.inBox2}>
                  {mbNick}
                </div>
              </div>
        
              <MailCompo
                classes={classes}
                setData={setData}
                mbMailling={mbMailling}
                idx={idx}
              />

            <SmsCompo
                classes={classes}
                setData={setData}
                mbSms={mbSms}
                idx={idx}
              />
        
              <div className={classes.twoBox}>
                <div className={classes.inBox1}>
                  {mbHp}
                </div>
                <div className={classes.inBox2}>
                  {mbTel}
                </div>
              </div>
        
              <div className={classes.twoBox}>

            <LevelCompo
                classes={classes}
                setData={setData}
                mbLevel={mbLevel}
                idx={idx}
              />

                <div className={classes.inBox2}>
                  {mbPoint}
                </div>
              </div>
        
              <div className={classes.twoBox}>
                <div className={classes.inBox1}>
                  {mbTodayLogin}
                </div>
                <div className={classes.inBox2}>
                  {mbDateTime}
                </div>
              </div>
        

            <RegionCompo
                classes={classes}
                setData={setData}
                mbRegion={mbRegion}
                idx={idx}
              />
        

            <StoreNameCompo
                classes={classes}
                setData={setData}
                mbStorname={mbStorname}
                idx={idx}
              />
        

            <PicCompo
                classes={classes}
                setData={setData}
                picId={picId}
                picList={picList}
                idx={idx}
              />
        
              <div className={classes.oneBox}>
                <Button 
                  variant="text"
                  onClick={() => {
                    navigate("/DashboardMain/memberEdit", {
                      state: { mb_no: mbNo }
                    });
                  }}
                >
                  수정
                </Button>
              </div>
          </div>
    







          <div className={classes.mobileItemBox}>

            <CeckCompo 
                classes={classes}
                checks={checks}
                setChecks={setChecks}
                mbNo={mbNo}
              />
        
              <div className={classes.oneBox}>
                {mbId}
              </div>
        
              <div className={classes.oneBox}>
                <Button 
                  variant="text"
                  onClick={() => {
                    navigate("/DashboardMain/memberEdit", {
                      state: { mb_no: mbNo }
                    });
                  }}
                >
                  수정
                </Button>
              </div>
          </div>
        </div>
    )
})




const CeckCompo = memo(({classes, checks, setChecks, mbNo}) => {

    return (
        <div className={classes.checkBox}>
            <Checkbox 
                checked={checks.includes(mbNo)}
                onChange={() => {
                    !checks.includes(mbNo) ?
                    setChecks([...checks, mbNo]) : 
                    setChecks([...checks.filter((item) => item !==  mbNo)])
                }}
            />
        </div>
    );
})

const MailCompo = memo(({classes, setData, mbMailling, idx}) => {

    return (
        <div className={classes.threeBox}>
            <Checkbox
                checked={mbMailling === 1 ? true : false}
                onChange={(e) => {
                  const input = e.target.value;
                  setData((prevArr) => {
                    return [
                      ...prevArr.slice(0, idx),
                      { 
                        mb_datetime: prevArr[idx].mb_datetime,
                        mb_hp: prevArr[idx].mb_hp,
                        mb_id: prevArr[idx].mb_id,
                        mb_level: prevArr[idx].mb_level,
                        mb_mailling: prevArr[idx].mb_mailling === 0 ? 1 : 0,
                        mb_name: prevArr[idx].mb_name,
                        mb_nick: prevArr[idx].mb_nick,
                        mb_no: prevArr[idx].mb_no,
                        mb_point: prevArr[idx].mb_point,
                        mb_region: prevArr[idx].mb_region,
                        mb_sms: prevArr[idx].mb_sms,
                        mb_storename: prevArr[idx].mb_storename,
                        mb_tel: prevArr[idx].mb_tel,
                        mb_today_login: prevArr[idx].mb_today_login,
                        pic_id: prevArr[idx].pic_id,
                      },
                      ...prevArr.slice(idx + 1, prevArr.length)
                    ];
                  });
                }}
            />
        </div>
    );
})

const SmsCompo = memo(({classes, setData, mbSms, idx}) => {

    return (
        <div className={classes.threeBox}>
            <Checkbox
                checked={mbSms === 1 ? true : false}
                onChange={(e) => {
                  const input = e.target.value;
                  setData((prevArr) => {
                    return [
                      ...prevArr.slice(0, idx),
                      { 
                        mb_datetime: prevArr[idx].mb_datetime,
                        mb_hp: prevArr[idx].mb_hp,
                        mb_id: prevArr[idx].mb_id,
                        mb_level: prevArr[idx].mb_level,
                        mb_mailling: prevArr[idx].mb_mailling,
                        mb_name: prevArr[idx].mb_name,
                        mb_nick: prevArr[idx].mb_nick,
                        mb_no: prevArr[idx].mb_no,
                        mb_point: prevArr[idx].mb_point,
                        mb_region: prevArr[idx].mb_region,
                        mb_sms: prevArr[idx].mb_sms === 0 ? 1 : 0,
                        mb_storename: prevArr[idx].mb_storename,
                        mb_tel: prevArr[idx].mb_tel,
                        mb_today_login: prevArr[idx].mb_today_login,
                        pic_id: prevArr[idx].pic_id,
                      },
                      ...prevArr.slice(idx + 1, prevArr.length)
                    ];
                  });
                }}
            />
        </div>
    );
})

const LevelCompo = memo(({classes, setData, mbLevel, idx}) => {

    return (
        <div className={classes.inBox1}>
            <FormControl size="small">
                <Select
                    labelId="select-small"
                    id="select-small"
                    sx={{ m:2 }}
                    value={mbLevel}
                    onChange={(e) => {
                      const input = e.target.value;
                      setData((prevArr) => {
                        return [
                          ...prevArr.slice(0, idx),
                          { 
                            mb_datetime: prevArr[idx].mb_datetime,
                            mb_hp: prevArr[idx].mb_hp,
                            mb_id: prevArr[idx].mb_id,
                            mb_level: input,
                            mb_mailling: prevArr[idx].mb_mailling,
                            mb_name: prevArr[idx].mb_name,
                            mb_nick: prevArr[idx].mb_nick,
                            mb_no: prevArr[idx].mb_no,
                            mb_point: prevArr[idx].mb_point,
                            mb_region: prevArr[idx].mb_region,
                            mb_sms: prevArr[idx].mb_sms,
                            mb_storename: prevArr[idx].mb_storename,
                            mb_tel: prevArr[idx].mb_tel,
                            mb_today_login: prevArr[idx].mb_today_login,
                            pic_id: prevArr[idx].pic_id,
                          },
                          ...prevArr.slice(idx + 1, prevArr.length)
                        ];
                      });
                    }}
                >
                    {[0,1,2,3,4,5,6,7,8,9,10].map((value, idx) => <MenuItem key={idx} value={value}>{value}</MenuItem>)}
                
                </Select>
            </FormControl>
        </div>
    );
})

const RegionCompo = memo(({classes, setData, mbRegion, idx}) => {

    return (
        <div className={classes.oneBox}>
            <TextField 
                value={mbRegion || ''} 
                onChange={(e) => {
                  const input = e.target.value;
                  setData((prevArr) => {
                    return [
                      ...prevArr.slice(0, idx),
                      { 
                        mb_datetime: prevArr[idx].mb_datetime,
                        mb_hp: prevArr[idx].mb_hp,
                        mb_id: prevArr[idx].mb_id,
                        mb_level: prevArr[idx].mb_level,
                        mb_mailling: prevArr[idx].mb_mailling,
                        mb_name: prevArr[idx].mb_name,
                        mb_nick: prevArr[idx].mb_nick,
                        mb_no: prevArr[idx].mb_no,
                        mb_point: prevArr[idx].mb_point,
                        mb_region: input,
                        mb_sms: prevArr[idx].mb_sms,
                        mb_storename: prevArr[idx].mb_storename,
                        mb_tel: prevArr[idx].mb_tel,
                        mb_today_login: prevArr[idx].mb_today_login,
                        pic_id: prevArr[idx].pic_id,
                      },
                      ...prevArr.slice(idx + 1, prevArr.length)
                    ];
                  });
                }}
                size='small' 
                hiddenlabel="true" 
                variant="outlined" 
            />
        </div>
    );
})

const StoreNameCompo = memo(({classes, setData, mbStorname, idx}) => {

    return (
        <div className={classes.oneBox}>
            <TextField 
                value={mbStorname || ''} 
                onChange={(e) => {
                  const input = e.target.value;
                  setData((prevArr) => {
                    return [
                      ...prevArr.slice(0, idx),
                      { 
                        mb_datetime: prevArr[idx].mb_datetime,
                        mb_hp: prevArr[idx].mb_hp,
                        mb_id: prevArr[idx].mb_id,
                        mb_level: prevArr[idx].mb_level,
                        mb_mailling: prevArr[idx].mb_mailling,
                        mb_name: prevArr[idx].mb_name,
                        mb_nick: prevArr[idx].mb_nick,
                        mb_no: prevArr[idx].mb_no,
                        mb_point: prevArr[idx].mb_point,
                        mb_region: prevArr[idx].mb_region,
                        mb_sms: prevArr[idx].mb_sms,
                        mb_storename: input,
                        mb_tel: prevArr[idx].mb_tel,
                        mb_today_login: prevArr[idx].mb_today_login,
                        pic_id: prevArr[idx].pic_id,
                      },
                      ...prevArr.slice(idx + 1, prevArr.length)
                    ];
                  });
                }}
                size='small' 
                hiddenlabel="true" 
                variant="outlined" 
            />
        </div>
    );
})

const PicCompo = memo(({classes, setData, picId, picList, idx}) => {

    return (
        <div className={classes.oneBox}>
            <FormControl size="small">
                <Select
                    labelId="select-small"
                    id="select-small"
                    value={picId}
                    onChange={(e) => {
                      const input = e.target.value;
                      setData((prevArr) => {
                        return [
                          ...prevArr.slice(0, idx),
                          { 
                            mb_datetime: prevArr[idx].mb_datetime,
                            mb_hp: prevArr[idx].mb_hp,
                            mb_id: prevArr[idx].mb_id,
                            mb_level: prevArr[idx].mb_level,
                            mb_mailling: prevArr[idx].mb_mailling,
                            mb_name: prevArr[idx].mb_name,
                            mb_nick: prevArr[idx].mb_nick,
                            mb_no: prevArr[idx].mb_no,
                            mb_point: prevArr[idx].mb_point,
                            mb_region: prevArr[idx].mb_region,
                            mb_sms: prevArr[idx].mb_sms,
                            mb_storename: prevArr[idx].mb_storename,
                            mb_tel: prevArr[idx].mb_tel,
                            mb_today_login: prevArr[idx].mb_today_login,
                            pic_id: input,
                          },
                          ...prevArr.slice(idx + 1, prevArr.length)
                        ];
                      });
                    }}
                >
                    {picList.length > 0 && picList.map((value, idx) => 
                                        <MenuItem key={idx} value={value['pic_id']}>{value['pic_name']}</MenuItem>
                    )}
                
                </Select>
            </FormControl>
        </div>
    );
})



export default memo(MemberConfigList)
